import { Box, xcss } from '@atlaskit/primitives';
import React, { lazy, Suspense } from 'react';

import { dynamicImport } from '@canvas/dynamic-import';

import { type TextLikeFieldType } from '../types.ts';

import { type EditComponentProps } from './types.ts';

const richTextEditorLoadingStyles = xcss({
  minHeight: 'size.400',
  width: '100%'
});

const preloadRichTextValuePopoverEdit = () =>
  dynamicImport(() => import('./RichTextValuePopoverEdit.tsx'));

const RichTextValuePopoverEdit = lazy(() =>
  preloadRichTextValuePopoverEdit().then(({ default: RichTextValuePopoverEdit }) => ({
    default: RichTextValuePopoverEdit
  }))
);

function RichTextValuePopoverEditLazy<Type extends TextLikeFieldType>(
  props: EditComponentProps<Type>
) {
  return (
    <Suspense
      fallback={
        <Box
          aria-busy="true"
          data-rich-text-edit-wrapper
          testId="rich-text-value-edit-loading"
          xcss={richTextEditorLoadingStyles}
        />
      }
    >
      <RichTextValuePopoverEdit {...props} />
    </Suspense>
  );
}

export default RichTextValuePopoverEditLazy;
